import { Heading } from '@sparemin/blockhead';
import React from 'react';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';

export type YouTubeVerificationStepProps = {
  isVerifying: boolean;
};

const YouTubeVerificationStep: React.FC<YouTubeVerificationStepProps> = ({
  isVerifying,
}) => {
  return (
    <SocialShareModalBody
      showRegenerateTextButton={false}
      isLoading={isVerifying}
      loadingTitle="Verifying..."
    >
      <Heading level={2} align="center">
        After verification we can continue getting ready for YouTube.
      </Heading>
    </SocialShareModalBody>
  );
};

export default YouTubeVerificationStep;
